import React from "react";
import { Link, useLocation } from "react-router-dom";

import { ReceiptCaptureCard } from "../components/ReceiptCaptureCard";
import { readPendingReceiptJobSnapshot, resolveReceiptReturnTo } from "../lib/receipt";
import { UI_TEXT_TONE } from "../lib/uiTone";

type ReceiptRouteState = {
  returnTo?: string;
  conversationId?: string;
  messageId?: string;
};

export default function ReceiptPopup() {
  const location = useLocation();
  const state = (typeof location.state === "object" && location.state ? location.state : {}) as ReceiptRouteState;
  const pendingSnapshot = readPendingReceiptJobSnapshot();
  const returnTo = resolveReceiptReturnTo({ routeState: location.state, pendingSnapshot });

  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto w-full max-w-xl">
        <section className="w-full rounded-[2.4rem] border border-white/80 bg-white/90 p-4 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <div className="mb-5">
            <p className="text-[11px] font-black tracking-[0.16em] text-[#A67C52]">領収書を整理</p>
            <h1 className={`text-2xl font-black tracking-tight ${UI_TEXT_TONE.title}`}>領収書を保存する</h1>
            <p className={`mt-2 text-sm leading-6 ${UI_TEXT_TONE.body}`}>
              写真を送るだけで、あとから見返しやすい形に整理します。
            </p>
          </div>

          <ReceiptCaptureCard
            returnTo={returnTo}
            conversationId={state.conversationId}
            messageId={state.messageId}
          />

          <div className="mt-5 text-center">
            <Link
              to="/receipt/history"
              className="text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]"
            >
              過去の領収書を見る →
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
}
